import TextWithImageInput from 'components/TextWithImageInput';
import { useRef } from 'react';
import CustomUpload, { CustomUploadRef } from 'views/Conversation/Sider/ToDoBundle/Upload';
import { Panel } from '../Panel';
import { useTranslate } from '@tolgee/react';

interface NewNoteInputProps {
  platform: General.PlatformUpperCase;
  storeId: string;
  conversationId: string;
  text: string;
  images: string[];
  onChange: (value: { text: string; images: string[] }) => void;
}

export const NewNoteInput = (props: NewNoteInputProps) => {
  const { platform, storeId, conversationId, text, images, onChange } = props;
  const { t } = useTranslate();

  const customUploadRef = useRef<CustomUploadRef>(null);

  return (
    <Panel title={t('备注')}>
      <TextWithImageInput
        text={text}
        images={images}
        onTextChange={(nextText) => onChange({ text: nextText, images })}
        onImagesChange={(nextImages) => onChange({ text, images: nextImages })}
        renderImageUpload={({ value, onChange, disabled: uploadDisabled }) => (
          <CustomUpload
            ref={customUploadRef}
            disabled={uploadDisabled}
            selfHosted
            platform={platform}
            internalStoreId={storeId}
            conversationId={conversationId}
            onChange={onChange}
            value={value}
            direct={false}
          />
        )}
        onPasteImage={(file) => customUploadRef.current?.handUpload(file)}
      />
    </Panel>
  );
};
